import { Record } from 'immutable';

export default class EmploymentContractRecord extends Record({
  id: undefined,
  collectiveAgreement: undefined,
  createdAt: undefined,
  createdBy: undefined,
  duties: undefined,
  employeeBankAccountNumber: undefined,
  employeeBenefits: undefined,
  employeeCity: undefined,
  employeeEmail: undefined,
  employeeFirstName: undefined,
  employeeIdentityNumber: undefined,
  employeeLastName: undefined,
  employeeName: undefined,
  employeePhoneNumber: undefined,
  employeePostalCode: undefined,
  employeeRelativePerson: undefined,
  employeeStreet1: undefined,
  employerName: undefined,
  employmentRateAmount: undefined,
  employmentRateType: undefined,
  employmentType: undefined,
  endDate: undefined,
  files: undefined,
  holidayPayRate: undefined,
  html: undefined,
  generatedHtml: undefined,
  incentiveSalaryAfterHour: undefined,
  incentiveSalaryIncreaseFraction: undefined,
  links: undefined,
  oneflowId: undefined,
  other: undefined,
  overtimeCompensation: undefined,
  periodOfNoticeMonthsEmployee: undefined,
  periodOfNoticeMonthsEmployer: undefined,
  probationaryPeriodEnd: undefined,
  probationaryPeriodStart: undefined,
  resource: undefined,
  rightToVacationDuring: undefined,
  rightToVacationInAdvance: undefined,
  salaryAmount: undefined,
  salaryAmountUntil: undefined,
  salaryPeriod: undefined,
  salaryType: undefined,
  services: undefined,
  schedule: undefined,
  signedByResourceAt: undefined,
  signedByUser: undefined,
  signedByUserAt: undefined,
  staffingCompany: undefined,
  startDate: undefined,
  substituteFor: undefined,
  substituteReason: undefined,
  terminatedByType: undefined,
  terminationDate: undefined,
  title: undefined,
  travelTimeCompensation: undefined,
  vacationRightDays: undefined,
  vacationSalaryIncluded: undefined,
  workerType: undefined,
  workHoursPerWeek: undefined,
  workPlace: undefined,
  workTimes: undefined,
}) {
}
